<template>
  <div id="app">
    <the-header></the-header>
    <the-crumb></the-crumb>
    <the-banner></the-banner>
    <div class="main">
      <router-view class="grading-content" />
    </div>
    <the-footer></the-footer>
    <!-- <siderbar></siderbar> -->
  </div>
</template>
<script>
import theHeader from "@/components/header";
import theFooter from "@/components/footer";
import theBanner from "@/components/banner";
import theCrumb from "@/components/crumb";
import siderbar from "@/components/sidebar";

export default {
  components: {
    theHeader,
    theFooter,
    theBanner,
    theCrumb,
    siderbar,
  },
};
</script>

<style lang="scss">
.grading-content {
  position: relative;
  // top: -20px;
  background: #fff;
  min-height: 200px;
}
.main {
  padding-bottom: 40px;
}
</style>
